import { create } from "zustand";
import { ActionsKey } from "../../../common/models/Actions";
import {
  DefaultListResponse,
  DefaultPageState,
} from "../../../common/models/StoreDefaultModel";

export type ActionedLevageMovementMaterial = {
  data: any;
  action: ActionsKey;
};

type LevageMovementMaterialDataType = {
  levageMaterialMovementList: any;
  detail: any | null;
  actioned: ActionedLevageMovementMaterial | null;
  totalItems?: number;
  setDetail: (detail: any | null) => void;
  setLevageMovementMaterialList: (roles: DefaultListResponse | null) => void;
  resetLevageMovementMaterialList: () => void;
  setActioned: (act: ActionedLevageMovementMaterial | null) => void;
  pageState: DefaultPageState;
  setPageState: (state: DefaultPageState) => void;
  resetPageState: () => void;
};

export const levageMaterialDefaultPageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
};

export const useLevageMovementMaterialStore =
  create<LevageMovementMaterialDataType>((set) => ({
    levageMaterialMovementList: [],
    detail: null,
    actioned: null,
    totalItems: 0,
    pageState: levageMaterialDefaultPageState,
    setDetail: (detail) => set((state) => ({ detail })),
    setLevageMovementMaterialList: (levageData) =>
      set((state) => ({
        levageMaterialMovementList: levageData?.member,
        totalItems: levageData?.totalItems,
      })),
    setActioned: (act) => set((state) => ({ actioned: act } as any)),
    resetLevageMovementMaterialList: () =>
      set((state) => ({
        levageMaterialMovementList: [],
        totalItems: 0,
      })),
    setPageState: (pageState) => set((state) => ({ pageState })),
    resetPageState: () =>
      set(() => ({
        pageState: {
          page: 1,
          itemsPerPage: 10,
        },
      })),
  }));
